import { createAction } from "~/utils/actions";

export default {
	...createAction("UPDATE_FUND_SELECTION"),
	...createAction("UPDATE_FUND_PROPORTION"),
	...createAction("VISIT_FONDSSKOLEN"),
};
